import React, { Component } from 'react';
import Logo from '../atoms/Logo';
import { CSSTransition } from 'react-transition-group';

class IntroStep1 extends Component {
  render() {
    return (
      <CSSTransition
        in={this.props.show}
        unmountOnExit
        classNames="IntroStep1"
        timeout={this.props.timeout}>
        <div className="IntroStep1">
          <div className="IntroStep1__spacer025" />
          <div className="IntroStep1__noflex">
            <Logo/>
          </div>
          <h1 className="h4 caps IntroStep1__noflex">Welcome to the<br/>Hall of Service</h1>
          <p className="copyHolder IntroStep1__noflex">
            The walls of the Hall of Service display soil collected from 1,701 towns, cities, suburbs and homesteads in New South Wales. These places were given as a home address by enlistees for the First Australian Imperial Force.
          </p>
          <p className="copyHolder IntroStep1__noflex">
            Embedded in the floor is soil collected from 100 significant military sites across the world.
          </p>
          <p className="copyHolder IntroStep1__noflex">
            In its broad spectrum of places, Fiona Hall's artwork explores and honours more than a century of Australian service and sacrifice in peacekeeping and conflict.
          </p>
        </div>
      </CSSTransition>
    )
  }
}

export default IntroStep1;